import React from 'react'
import { ResponsiveContainer, Line, YAxis, XAxis, Tooltip, ComposedChart, Area, ReferenceLine } from 'recharts'
import moment from 'moment'

const Tick = ({ x, y, stroke, payload }) => {
  const dt_moment = moment(payload.value)

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">{dt_moment.format('HH')}</text>
      {(dt_moment.format('HH') === "00") &&
        <text x={0} y={0} dy={32} textAnchor="middle" fill="#666">{dt_moment.format('YYYY-MM-DD')}</text>
      }
    </g>
  )
}

const color = ["#FFFFFF", "#FFD580", "#FFC0CB"]

const TimeSeriesPlot = ({ data, threshold_key, items, day, hour, yLeft={}, referenceLines=[] }) => {
  const t0 = moment(day).startOf('day').toDate()

  return (
    data &&
      <ResponsiveContainer width='100%' height='100%'>
        <ComposedChart data={data}  margin={{ top: 10, left: 0, right: 55, bottom: 15 }}>
          {(threshold_key).map((i) => 
            <Area type="monotone" dataKey={i} fill={color[i.split("-")[1]]} stroke="none" strokeWidth={0} legendType="none" tooltipType="none" dot={false} activeDot={false} />
          )}

          <YAxis domain={yLeft["range"]} label={{ value: yLeft["label"], angle: -90, position: 'insideLeft' }}/>
          
          <XAxis type='number' dataKey='time' scale='Time' allowDataOverflow={true} domain = {[moment(new Date(t0)).add(hour[0], 'hours').toDate().getTime(), moment(new Date(t0)).add(hour[1], 'hours').toDate().getTime()]} interval={0} tick={<Tick hour={hour}/>} ticks={Array.from({ length: hour[1] - hour[0] + 1 }, (_, i) => hour[0] + i).map((i) => moment(new Date(t0)).add(i, 'hours').toDate().getTime())} />  

          {referenceLines.map((i) =>
            <ReferenceLine y={i} stroke="grey" label={{
              value: i,
              position: "right",
            }}/>
          )}

          {(items).map((i) => 
            <Line type="monotone" dataKey={i["dataKey"]} name={i["name"]} stroke={i["stroke"]} dot={false} />
          )}

          {(data.length > 2 || threshold_key.length === 0) &&
            <Tooltip labelFormatter={t =>  moment(t).format('YYYY-MM-DD HH:mm:ss')} />
          }
          {/* <Legend /> */}
        </ComposedChart>
      </ResponsiveContainer>
  )
}

export default TimeSeriesPlot
